import type { UseMutateFunction } from '@tanstack/react-query'

import type { ProductExtended } from '../../types'

export const updatedProductAlias = (product?: any) =>
  !(product?.alias || product?.name) || product?.alias === product?.name ? null : product?.alias

export const updatedProductAliasDescription = (product?: any) =>
  !(product?.aliasDescription || product?.desc) || product?.aliasDescription === product?.desc
    ? null
    : product?.aliasDescription

export const handleMultiProductSelect = ({
  updateProduct,
  groupedProducts,
  isAllSelected,
  policyId,
}: {
  updateProduct: UseMutateFunction<
    any,
    unknown,
    { policyId: number; payload: { products: any[] } },
    unknown
  >
  groupedProducts?: ProductExtended[]
  isAllSelected?: boolean
  policyId: number
}) => {
  const updateProducts = groupedProducts
    ?.filter(p => groupedProducts && (isAllSelected ? p.isSelected : !p.isSelected))
    ?.map(productFromGroup => ({
      productId: productFromGroup.id,
      isSelected: isAllSelected ? false : !productFromGroup.isSelected,
      priceId: productFromGroup.priceId,
      isMandatory: Boolean(productFromGroup.isMandatory),
      quantityLimit: isAllSelected
        ? productFromGroup.quantityLimit || 1
        : productFromGroup.quantityLimit,
      alias: isAllSelected ? updatedProductAlias(productFromGroup) : productFromGroup.alias,
      aliasDescription: isAllSelected
        ? updatedProductAliasDescription(productFromGroup)
        : productFromGroup.aliasDescription,
    }))

  if (updateProducts && updateProducts.length > 0) {
    updateProduct({
      policyId,
      payload: {
        products: updateProducts,
      },
    })
  }
}
